import React, { useEffect, useState } from "react";
import * as url from "../../../../helpers/url_helper";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import ConfirmationModal from "../../../../components/Common/ConfirmationModal";
import axios from "axios";
import ChipsDataTable from "./ChipsDetail/ChipsDataTable";
import { AssignIcon, DeleteIcon } from "../../../../assets/svg";
import { ActionButton } from "../../../../components/Common/button";
import AssignRoomModal from "./AssignRoomModal";

export interface LockControlProps {
  userId: any;
  selectedPremise?: any;
}
function LockList({ userId, selectedPremise }: LockControlProps) {
  const selectedRooms = useSelector(
    (state: any) => state.APIResponse.selectedRooms
  );
  const token = localStorage.getItem("Authorization");

  const [isMultiDeleteModalOpen, setMultiDeleteModalOpen] = useState(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteData, setDeleteData] = useState<any>();
  const [isReload, setReload] = useState<boolean>(false);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [assignData, setAssignData] = useState<any>({});
  const [isAssignRoomModalOpen, setIsAssignRoomModalOpen] = useState(false);

  const columns = [
    {
      name: "Name",
      selector: (row: any) => row.name || "-",
      sortable: true,
    },
    {
      name: "	Room Name",
      selector: (row: any) => row.roomName || "-",
      sortable: true,
    },

    {
      name: "Actions",
      grow: 2,
      cell: (row: any) => (
        <div className="d-flex align-items-center" style={{ gap: "12px" }}>
          <ActionButton
            id="DeleteIconButton"
            title="Delete"
            icon={<DeleteIcon />}
            onClick={() => handleDeleteClick(row)}
          />
          <ActionButton
            id="AssignIconButton"
            title="Assign Room"
            icon={<AssignIcon />}
            onClick={() => handleAssignClick(row)}
          />
        </div>
      ),
    },
  ];

  const handleRefresh = () => {
    setReload((prev) => !prev);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      handleRefresh();
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  const deleteLockApiCall = () => {
    setLoading(true);
    const reqObj = {
      lockId: deleteData.id,
    };

    axios
      .delete(`${url.BASE_URL}${url.DELETE_LOCK}`, {
        data: reqObj,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        toast.success(res.data.msg);
        handleRefresh();
        setDeleteModalOpen(false);
        setDeleteData(null);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleDeleteClick = (rowData: any) => {
    setDeleteModalOpen(!isDeleteModalOpen);
    setDeleteData(rowData);
  };
  const multiDeleteLockApiCall = () => {
    setLoading(true);
    const reqObj = {
      lockId: selectedRows?.map((item) => item._id),
    };
    axios
      .delete(`${url.BASE_URL}${url.DELETE_LOCK}`, {
        data: reqObj,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        toast.success(res.data.msg);
        handleRefresh();
        setMultiDeleteModalOpen(false);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  const handleDeleteAll = () => {
    setMultiDeleteModalOpen(!isMultiDeleteModalOpen);
  };
  const handleAssignClick = (row: any) => {
    if (row !== undefined) {
      setIsAssignRoomModalOpen(!isAssignRoomModalOpen);
      setAssignData(row);
    }
  };
  return (
    <div>
      {isDeleteModalOpen && (
        <ConfirmationModal
          headerTitle="Delete Lock?"
          text="Are you sure you want to delete this Lock ? This action cannot be undone."
          buttonText="Delete"
          onClick={() => {
            deleteLockApiCall();
          }}
          cancleBtnClick={() => setDeleteModalOpen(false)}
          loading={loading}
        />
      )}
      {isMultiDeleteModalOpen && (
        <ConfirmationModal
          headerTitle="Delete Lock?"
          text="Are you sure you want to delete this Lock ? This action cannot be undone."
          buttonText="Delete"
          onClick={() => {
            multiDeleteLockApiCall();
          }}
          cancleBtnClick={() => setMultiDeleteModalOpen(false)}
          loading={loading}
        />
      )}
      {isAssignRoomModalOpen && (
        <AssignRoomModal
          headerTitle="Assign Room"
          idName={"Locklist"}
          assignData={assignData}
          handleRefresh={handleRefresh}
          cancleBtnClick={() => {
            setIsAssignRoomModalOpen(false);
            setAssignData({});
          }}
        />
      )}

      <ChipsDataTable
        apiURL={`${url.BASE_URL}${url.GET_LOCK_LIST}`}
        title="Lock List"
        customStyles={customStyles}
        selectedRoomID={selectedRooms}
        columns={columns}
        isReload={isReload}
        idName={"Locklist"}
        loading={loading}
        setLoading={setLoading}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        userId={userId}
        selectedPremise={selectedPremise}
        expandableRows={false}
        ExpandCollapseIcon={ExpandCollapseIcon}
        handleDeleteAll={handleDeleteAll}
      />
    </div>
  );
}

export default LockList;

export const customStyles: any = {
  tableWrapper: {
    style: {
      minWidth: "1100px",
    },
  },
  subHeader: {
    style: {
      padding: "0px",
      margin: "0px",
    },
  },
  headRow: {
    style: {
      backgroundColor: "#EFF2F7",
      fontWeight: "bold",
      fontSize: "14px",
      borderBottom: "none",
    },
  },
  rows: {
    style: {
      fontSize: "14px",
      color: "#343a40",
      borderBottom: "none",
    },
  },
  cells: {
    style: {
      fontSize: "14px",
      color: "#343a40",
      borderBottom: "none",
    },
  },
};

export const ExpandCollapseIcon = ({ expanded }: { expanded: boolean }) => {
  return (
    <div
      className="d-flex justify-content-center align-items-center  "
      style={{ cursor: "pointer", width: "32px", height: "32px" }}
    >
      <i
        className={`bx ${
          expanded ? "bx-caret-down" : "bx-caret-right"
        } text-dark fs-5`}
      ></i>
    </div>
  );
};
